import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    Handler,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { CustomHandler } from "@tJohnstonCompanies/Handlers/CustomHandlerCreator";
import { QuoteItems } from "@tJohnstonCompanies/Handlers/RfqQuote/RfqQuoteNewState";
import { addQuoteDataFields, QuoteModel } from "@tJohnstonCompanies/Services/CustomRfqService";

interface QuoteAPIParameter extends ApiParameter {
    quoteItems: QuoteItems[];
}

type HandlerType = CustomHandler<{ quoteItems: QuoteItems[] }>;

export const DispatchQuotes: HandlerType = (props: any) => {
    props.dispatch({
        type: "CustomQuotes/RfqQuoteNewState/SetQuoteNewState",
        quoteItems: props.parameter.quoteItems,
    });
};

export const chain = [DispatchQuotes];

const dispatchQuotes = createHandlerChainRunner(chain, "SetQuoteNewState");
export default dispatchQuotes;
